'use client'

import Link from '@components/primitives/Link'
import absoluteUrl from '@lib/routes/helpers/absoluteUrl'
import stripTreatmentAndPaidFromSlug from '@modules/trials/search/helpers/stripTreatmentAndPaidFromSlug'
import { usePathname } from 'next/navigation'

export default function ClearAllButton() {
  const pathname = usePathname()
  return (
    <Link
      className='my-2 text-sm font-semibold text-neutral500 antialiased'
      href={absoluteUrl(
        stripTreatmentAndPaidFromSlug({
          pathname,
        }),
      )}
      prefetch={true}
    >
      Clear All
    </Link>
  )
}
